import RelatedContentCard from '@klv/molecules/related-content-card';
import type { TColorVariant } from '@klv/shared/styles/types';
import {
  CardContainer, CardContainerWrapper, RelatedContentGrid, StyledHeadline, StyledRelatedContent,
} from './styles';
import type { IRelatedContent } from './types';

const RelatedContent = ({
  background, cards, headline = '', solidCardHoverColor = 'none', ...props
}: IRelatedContent) => (
  <StyledRelatedContent $background={background as TColorVariant} {...props}>
    <RelatedContentGrid>
      {headline && <StyledHeadline $background={background} variant="h3">{headline}</StyledHeadline>}
      <CardContainerWrapper>
        <CardContainer cardCount={cards.length}>
          {cards.map((card) => (
            <RelatedContentCard
              {...card.relatedContentCard}
              key={JSON.stringify(card.relatedContentCard)}
              solidCardHoverColor={solidCardHoverColor}
              variant={background === 'dark' ? 'dark' : 'light'}
            />
          ))}
        </CardContainer>
      </CardContainerWrapper>
    </RelatedContentGrid>
  </StyledRelatedContent>
);

export default RelatedContent;
